const PRODUCTS_PAGE = {
    pageTitle: {
        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
        en: "Products | NAPIRE Inc."
    },
    metaDescription: {
        ja: "NAPIRE\u304C\u624B\u304C\u3051\u308B\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u306E\u3054\u7D39\u4ECB\u3002\u304A\u3084\u306E\u306D\u3001HITOHA\u3001\u5BB6\u96FB\u30AB\u30EB\u30C6\u3001READY CLUB\u3001SAKEME\u3001DAYO\u3001CH\u016AN\u2014\u2014\u66AE\u3089\u3057\u306B\u5C4A\u304F\u30B5\u30FC\u30D3\u30B9\u3092\u516C\u958B\u3057\u3066\u3044\u307E\u3059\u3002",
        en: "Explore NAPIRE\u2019s own products\u2014Oyanone, HITOHA, Kaden Karte, READY CLUB, SAKEME, DAYO, and CH\u016AN\u2014services built for everyday life."
    },
    metaKeywords: {
        ja: "NAPIRE,\u30D7\u30ED\u30C0\u30AF\u30C8,\u304A\u3084\u306E\u306D,HITOHA,\u5BB6\u96FB\u30AB\u30EB\u30C6,READY CLUB,SAKEME,DAYO,CH\u016AN,\u81EA\u793E\u30B5\u30FC\u30D3\u30B9",
        en: "NAPIRE,products,Oyanone,HITOHA,Kaden Karte,READY CLUB,SAKEME,DAYO,CHUN,consumer apps"
    },
    heroLabel: {
        ja: "Products",
        en: "Products"
    },
    heroBrand: {
        ja: "NAPIRE",
        en: "NAPIRE"
    },
    heroTitle: {
        ja: "\u66AE\u3089\u3057\u306B\u5C4A\u304F\u3001\n\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u3002",
        en: "Products that reach\neveryday life."
    },
    heroLead: {
        ja: "\u6CD5\u4EBA\u5411\u3051\u306E\u5B9F\u88C5\u529B\u3092\u3001\u65E5\u5E38\u306E\u4F53\u9A13\u3078\u3002\u5BB6\u65CF\u30FB\u5065\u5EB7\u30FB\u4F4F\u307E\u3044\u30FB\u5099\u3048\u30FB\u597D\u307F\u30FB\u3064\u306A\u304C\u308A\u2014\u2014\u73FE\u5834\u3067\u78E8\u3044\u305FAI\u3068\u30AF\u30E9\u30A6\u30C9\u3092\u3001\u30D7\u30ED\u30C0\u30AF\u30C8\u3068\u3057\u3066\u516C\u958B\u3057\u3066\u3044\u307E\u3059\u3002",
        en: "Enterprise-grade AI and cloud, shaped into everyday products\u2014for family, health, the home, preparedness, taste, and connection."
    },
    heroCta: {
        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8\u3092\u898B\u308B",
        en: "Browse products"
    },
    heroCta2: {
        ja: "\u304A\u554F\u3044\u5408\u308F\u305B",
        en: "Contact us"
    },
    countLabel: {
        ja: "\u516C\u958B\u4E2D\u306E\u30D7\u30ED\u30C0\u30AF\u30C8",
        en: "Live products"
    },
    jumpLabel: {
        ja: "\u4E00\u89A7",
        en: "Jump to"
    },
    visitLabel: {
        ja: "\u30B5\u30A4\u30C8\u3092\u898B\u308B",
        en: "Visit site"
    },
    appStoreLabel: {
        ja: "App Store",
        en: "App Store"
    },
    googlePlayLabel: {
        ja: "Google Play",
        en: "Google Play"
    },
    externalHint: {
        ja: "\u5916\u90E8\u30B5\u30A4\u30C8\u3078\u79FB\u52D5\u3057\u307E\u3059",
        en: "Opens external site"
    },
    philosophyLabel: {
        ja: "Our approach",
        en: "Our approach"
    },
    philosophyTitle: {
        ja: "\u5B9F\u88C5\u306E\u529B\u3092\u3001\n\u65E5\u5E38\u306E\u30D7\u30ED\u30C0\u30AF\u30C8\u3078\u3002",
        en: "Engineering strength,\nmade for daily life."
    },
    philosophyText: {
        ja: "NAPIRE\u306F\u3001\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u30FB\u30AF\u30E9\u30A6\u30C9\u306E\u4F34\u8D70\u3067\u57F9\u3063\u305F\u8A2D\u8A08\u529B\u3092\u3001\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u306B\u3082\u305D\u306E\u307E\u307E\u6D3B\u304B\u3057\u3066\u3044\u307E\u3059\u3002\u4F01\u753B\u304B\u3089\u958B\u767A\u30FB\u904B\u7528\u307E\u3067\u30EF\u30F3\u30C1\u30FC\u30E0\u3067\u624B\u304C\u3051\u3001\u4F7F\u3044\u7D9A\u3051\u3089\u308C\u308B\u4F53\u9A13\u3092\u5C4A\u3051\u307E\u3059\u3002",
        en: "The same craft we bring to enterprise AI, DX, and cloud work powers our own products\u2014one team from concept through build and ops, focused on experiences people keep using."
    },
    ctaTitle: {
        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8\u9023\u643A\u30FB\u5354\u696D\u306E\u3054\u76F8\u8AC7",
        en: "Partnerships & product inquiries"
    },
    ctaText: {
        ja: "\u63B2\u8F09\u30D7\u30ED\u30C0\u30AF\u30C8\u3078\u306E\u3054\u8CEA\u554F\u3001\u5354\u696D\u3001\u57CB\u3081\u8FBC\u307F\u9023\u643A\u306A\u3069\u3001\u304A\u6C17\u8EFD\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
        en: "Questions about these products, partnerships, or integrations\u2014reach out anytime."
    },
    ctaBtn: {
        ja: "\u30E1\u30FC\u30EB\u3067\u76F8\u8AC7",
        en: "Email us"
    }
};
const PRODUCTS = [
    {
        id: "oyanone",
        theme: "oyanone",
        url: "https://oyanone.napire.co.jp/",
        ogImage: "https://oyanone.napire.co.jp/opengraph-image.jpg",
        appStoreUrl: "https://apps.apple.com/jp/app/%E3%81%8A%E3%82%84%E3%81%AE%E3%81%AD/id6794542572",
        googlePlayUrl: "https://play.google.com/store/apps/details?id=jp.oyanone.app&hl=ja",
        mark: {
            ja: "\u304A\u3084\u306E\u306D",
            en: "Oyanone"
        },
        category: {
            ja: "\u5BB6\u65CF\u306E\u7269\u8A9E",
            en: "Family stories"
        },
        name: {
            ja: "\u304A\u3084\u306E\u306D",
            en: "Oyanone"
        },
        tagline: {
            ja: "\u89AA\u306E\u58F0\u3092\u3001\u5BB6\u65CF\u306E\u7269\u8A9E\u306B\u3002",
            en: "A parent\u2019s voice, into a family story."
        },
        desc: {
            ja: "\u805E\u3044\u3066\u304A\u304D\u305F\u304B\u3063\u305F\u3053\u3068\u3092\u3001\u6BCE\u9031\u3072\u3068\u3064\u3002\u58F0\u3067\u7B54\u3048\u308B\u3060\u3051\u3067\u3001AI\u304C\u4EBA\u751F\u306E\u7269\u8A9E\u306B\u6574\u3048\u307E\u3059\u3002\u5E83\u544A\u306A\u3057\u30FB\u516C\u958B\u7BC4\u56F2\u306F\u5BB6\u65CF\u3060\u3051\u3002",
            en: "One weekly question. Speak the answer\u2014AI gently shapes it into a life story. No ads; sharing stays with the family you invite."
        },
        highlights: [
            {
                ja: "\u58F0\u3067\u304B\u3093\u305F\u3093\u8A18\u9332",
                en: "Voice-first recording"
            },
            {
                ja: "AI\u304C\u3084\u3055\u3057\u304F\u7DE8\u96C6",
                en: "Gentle AI editing"
            },
            {
                ja: "\u5BB6\u65CF\u3060\u3051\u3067\u5171\u6709",
                en: "Family-only sharing"
            }
        ]
    },
    {
        id: "hitoha",
        theme: "hitoha",
        url: "https://hitoha.napire.co.jp/",
        ogImage: "https://hitoha.napire.co.jp/og.png",
        mark: {
            ja: "H",
            en: "H"
        },
        category: {
            ja: "\u7CBE\u5B50\u30FB\u5375\u5B50\u753B\u50CF\u30EC\u30D3\u30E5\u30FC",
            en: "Sperm & oocyte review"
        },
        name: {
            ja: "HITOHA",
            en: "HITOHA"
        },
        tagline: {
            ja: "\u7CBE\u5B50\u30FB\u5375\u5B50\u306E\u753B\u50CF\u3092\u3001AI\u3067\u6574\u7406\u3002\u5143\u80DA\u57F9\u990A\u58EB\u306B\u76F8\u8AC7\u3002",
            en: "AI organizes sperm and oocyte images\u2014then consult an embryologist."
        },
        desc: {
            ja: "\u30AF\u30EA\u30CB\u30C3\u30AF\u3067\u3082\u3089\u3063\u305F\u753B\u50CF\u306E\u300C\u3069\u3053\u3092\u898B\u308C\u3070\u3044\u3044\uFF1F\u300D\u30923\u5206\u3067\u30EC\u30DD\u30FC\u30C8\u3002\u898B\u3048\u3066\u3044\u308B\u3053\u3068\u30FB\u308F\u304B\u3089\u306A\u3044\u3053\u3068\u30FB\u533B\u5E2B\u306B\u805E\u304F\u8CEA\u554F\u3092\u6574\u7406\u3057\u3001\u5FC5\u8981\u306A\u3068\u304D\u306F\u5143\u80DA\u57F9\u990A\u58EB\u3078\u76F8\u8AC7\u3067\u304D\u307E\u3059\u3002",
            en: "Turn clinic images into a clear 3-minute report\u2014what\u2019s visible, what\u2019s unknown, and questions for your doctor\u2014with optional review by a former embryologist."
        },
        highlights: [
            {
                ja: "AI\u89B3\u5BDF\u30EC\u30DD\u30FC\u30C8",
                en: "AI observation report"
            },
            {
                ja: "\u8A3A\u5BDF\u3067\u805E\u304F\u8CEA\u554F\u6574\u7406",
                en: "Doctor question notes"
            },
            {
                ja: "\u5143\u80DA\u57F9\u990A\u58EB\u30EC\u30D3\u30E5\u30FC",
                en: "Embryologist review"
            }
        ]
    },
    {
        id: "kadenkarte",
        theme: "kaden",
        url: "https://kadenkarte.napire.co.jp/",
        ogImage: "https://kadenkarte.napire.co.jp/og.png",
        mark: {
            ja: "\u5BB6",
            en: "\u5BB6"
        },
        category: {
            ja: "\u4F4F\u307E\u3044\u30FB\u5BB6\u96FB",
            en: "Home & appliances"
        },
        name: {
            ja: "\u5BB6\u96FB\u30AB\u30EB\u30C6",
            en: "Kaden Karte"
        },
        tagline: {
            ja: "\u5BB6\u96FB\u306E\u3053\u3068\u3001\u305C\u3093\u3076\u899A\u3048\u3066\u304A\u304F\u3002",
            en: "Remember everything about your appliances."
        },
        desc: {
            ja: "\u578B\u756A\u30E9\u30D9\u30EB\u3092\u64AE\u308B\u3060\u3051\u3002\u4FDD\u8A3C\u671F\u9650\u3082\u3001\u304A\u624B\u5165\u308C\u3082\u3001\u6545\u969C\u6642\u306B\u5FC5\u8981\u306A\u3053\u3068\u3082\u3001\u5BB6\u65CF\u3067\u5171\u6709\u3057\u306A\u304C\u3089\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002",
            en: "Snap the model label. Warranties, care schedules, and repair essentials\u2014managed and shared with family."
        },
        highlights: [
            {
                ja: "AI\u30E9\u30D9\u30EB\u8AAD\u53D6",
                en: "AI label scan"
            },
            {
                ja: "\u4FDD\u8A3C\u30FB\u304A\u624B\u5165\u308C\u901A\u77E5",
                en: "Warranty & care alerts"
            },
            {
                ja: "\u4FEE\u7406\u76F8\u8AC7\u30B7\u30FC\u30C8",
                en: "Repair consult sheets"
            }
        ]
    },
    {
        id: "ready",
        theme: "ready",
        url: "https://ready.napire.co.jp/",
        ogImage: "https://ready.napire.co.jp/og.png",
        mark: {
            ja: "R",
            en: "R"
        },
        category: {
            ja: "\u9632\u707D\u30FB\u5099\u3048",
            en: "Preparedness"
        },
        name: {
            ja: "READY CLUB",
            en: "READY CLUB"
        },
        tagline: {
            ja: "\u5099\u3048\u3092\u3001\u66AE\u3089\u3057\u306E\u7FD2\u6163\u306B\u3002",
            en: "Make preparedness a living habit."
        },
        desc: {
            ja: "\u308F\u304C\u5BB6\u306B\u5FC5\u8981\u306A\u5099\u84C4\u3092\u8A3A\u65AD\u3057\u3001\u671F\u9650\u7BA1\u7406\u30FB\u5165\u308C\u66FF\u3048\u30FB\u9632\u707D\u8A13\u7DF4\u307E\u3067\u7D9A\u3051\u3089\u308C\u308B\u30B5\u30FC\u30D3\u30B9\u3002\u4E00\u5EA6\u8CB7\u3063\u3066\u7D42\u308F\u308A\u306B\u3057\u306A\u3044\u9632\u707D\u3078\u3002",
            en: "Diagnose what your household needs, then keep stock, expiry, restocking, and drills going\u2014preparedness that doesn\u2019t stop at purchase."
        },
        highlights: [
            {
                ja: "\u5BB6\u5EAD\u5225\u306E\u5099\u3048\u8A3A\u65AD",
                en: "Household stock diagnosis"
            },
            {
                ja: "\u671F\u9650\u524D\u901A\u77E5",
                en: "Expiry reminders"
            },
            {
                ja: "\u30ED\u30FC\u30EA\u30F3\u30B0\u30B9\u30C8\u30C3\u30AF",
                en: "Rolling stock support"
            }
        ]
    },
    {
        id: "dayo",
        theme: "dayo",
        url: "https://dayo.napire.co.jp/",
        ogImage: "https://dayo.napire.co.jp/og.png",
        mark: {
            ja: "D",
            en: "D"
        },
        category: {
            ja: "\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3",
            en: "Messaging"
        },
        name: {
            ja: "DAYO",
            en: "DAYO"
        },
        tagline: {
            ja: "\u8FD4\u3055\u306A\u304F\u3066\u3082\u3001\u3064\u306A\u304C\u308C\u308B\u3002",
            en: "Stay close\u2014without the reply pressure."
        },
        desc: {
            ja: "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u524D\u306B\u6C17\u914D\u304C\u4F1D\u308F\u308B\u201C\u6C17\u914D\u30D5\u30A1\u30FC\u30B9\u30C8\u201D\u306E\u30E1\u30C3\u30BB\u30F3\u30B8\u30E3\u30FC\u3002Pulse\u30FBAI\u30AD\u30E3\u30C3\u30C1\u30A2\u30C3\u30D7\u30FB\u4E88\u5B9A\u6574\u7406\u3067\u3001\u3064\u306A\u304C\u308B\u8CA0\u62C5\u3092\u6E1B\u3089\u3057\u307E\u3059\u3002",
            en: "A presence-first messenger\u2014Pulse, AI catch-up, and smart plans that shrink the weight of staying in touch."
        },
        highlights: [
            {
                ja: "Pulse\uFF08\u6C17\u914D\uFF09",
                en: "Pulse presence"
            },
            {
                ja: "AI\u30AD\u30E3\u30C3\u30C1\u30A2\u30C3\u30D7",
                en: "AI catch-up"
            },
            {
                ja: "Smart Plan",
                en: "Smart Plan"
            }
        ]
    },
    {
        id: "sakeme",
        theme: "sakeme",
        url: "https://sakeme.napire.co.jp/",
        ogImage: "https://sakeme.napire.co.jp/og.png",
        mark: {
            ja: "\u25CF",
            en: "\u25CF"
        },
        category: {
            ja: "\u65E5\u672C\u9152",
            en: "Sake"
        },
        name: {
            ja: "SAKEME",
            en: "SAKEME"
        },
        tagline: {
            ja: "\u30E9\u30D9\u30EB\u3092\u5411\u3051\u308B\u3002\u597D\u304D\u304C\u308F\u304B\u308B\u3002",
            en: "Point at the label. Know what you like."
        },
        desc: {
            ja: "\u5199\u3059\u3060\u3051\u3067\u9298\u67C4\u30FB\u8A55\u4FA1\u30FB\u3042\u306A\u305F\u3068\u306E\u76F8\u6027\u307E\u3067\u3002\u98F2\u3080\u307B\u3069\u8CE2\u304F\u306A\u308B\u3001\u65E5\u672C\u9152\u30D1\u30FC\u30BD\u30CA\u30EB\u30AC\u30A4\u30C9\u3067\u3059\u3002",
            en: "Scan a label for name, ratings, and your personal match\u2014a sake guide that gets smarter with every pour."
        },
        highlights: [
            {
                ja: "\u30E9\u30D9\u30EB\u30B9\u30AD\u30E3\u30F3",
                en: "Label scan"
            },
            {
                ja: "#\u30B5\u30B1\u76EE\u8A3A\u65AD",
                en: "Taste profiling"
            },
            {
                ja: "\u76F8\u6027\u30B9\u30B3\u30A2",
                en: "Match scores"
            }
        ]
    },
    {
        id: "chun",
        theme: "chun",
        url: "https://chun-shochu.napire.co.jp/",
        ogImage: "https://chun-shochu.napire.co.jp/og.png",
        mark: {
            ja: "\u914E",
            en: "\u914E"
        },
        category: {
            ja: "\u713C\u914E",
            en: "Shochu"
        },
        name: {
            ja: "CH\u016AN",
            en: "CH\u016AN"
        },
        tagline: {
            ja: "\u713C\u914E\u306E\u597D\u307F\u3001\u30C1\u30E5\u30FC\u30CB\u30F3\u30B0\u3057\u3088\u3046\u3002",
            en: "Tune your shochu taste."
        },
        desc: {
            ja: "\u30E9\u30D9\u30EB\u3092\u64AE\u308B\u3002\u9999\u308A\u3092\u8A18\u9332\u3059\u308B\u3002\u6B21\u306E\u4E00\u676F\u304C\u898B\u3064\u304B\u308B\u3002\u98F2\u3080\u307B\u3069\u81EA\u5206\u306E\u201C\u504F\u611B\u201D\u304C\u308F\u304B\u308B\u713C\u914E\u30A2\u30D7\u30EA\u3067\u3059\u3002",
            en: "Scan labels, log aromas, find the next glass\u2014a shochu app that maps your personal obsessions."
        },
        highlights: [
            {
                ja: "\u30E9\u30D9\u30EB\u30B9\u30AD\u30E3\u30F3",
                en: "Label scan"
            },
            {
                ja: "\u5473\u899A\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
                en: "Taste profile"
            },
            {
                ja: "\u4ECA\u591C\u306E\u30DA\u30A2\u30EA\u30F3\u30B0",
                en: "Night pairing"
            }
        ]
    }
];
function getProducts() {
    return PRODUCTS;
}

//# sourceMappingURL=products.e4a12948.js.map
